import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import {
  useDeletePlanMenuToFotoboxesMutation,
  useSendPlanMenuToFotoboxesMutation,
} from '../../../../core/api/PlanMenuApi'
import { IPlanMenuDto } from '../../../../core/api/dto/PlanMenuDto'
import { uniqFilter } from '../../DishesPage/hooks/useSentOnFotobox'

interface UseSentPlanMenuOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: IPlanMenuDto[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentPlanMenuOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendPlanMenu: (value: string[]) => void
  onDeletePlanMenuStation: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentPlanMenuOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentPlanMenuOnFotoboxProps): UseSentPlanMenuOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )

  const [sendPlanMenuToFotoboxes, { isLoading: isLoadingSend }] =
    useSendPlanMenuToFotoboxesMutation()
  const [deletePlanMenuToFotoboxes] = useDeletePlanMenuToFotoboxesMutation()

  const choosePlanMenu = tableData
    .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendPlanMenu = (value: string[]) => {
    if (value.length && choosePlanMenu.length) {
      sendPlanMenuToFotoboxes({
        planMenusGuids: choosePlanMenu,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('План-меню успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeletePlanMenuStation = (value: string[]) => {
    if (value.length && choosePlanMenu.length) {
      deletePlanMenuToFotoboxes({
        planMenusGuids: choosePlanMenu,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('План-меню успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeletePlanMenuStation,
    onSendPlanMenu,
    isLoadingSend,
  }
}
